var img = "data:image/svg+xml,%3csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M1 1L7 7L13 1' stroke='%23191919' stroke-width='1.5'/%3e%3c/svg%3e";
  export default img;